<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="$modal.closeModal"
    >
      <header class="m-the-modal-header">
        <h5>
          {{ $t('mEditionProductSalesLettersModalUndefined.title') }}
        </h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section
        key="modalSection"
        class="m-the-modal-section"
      >
        <p>
          {{ $t('mEditionProductSalesLettersModalUndefined.messageUndefined.first') }}
        </p>
        <small class="font-weight-bold text-color-billing-primary">
          {{ $t('mEditionProductSalesLettersModalUndefined.messageUndefined.second') }}
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionProductSalesLettersModalUndefined',

  data () {
    return {
      academiaId: '',

      buttonPrimary: {
        action: this.$t('mEditionProductSalesLettersModalUndefined.buttonPrimary'),
        class: 'a-button-products-primary',
        sending: false,
        type: 'submit'
      }
    }
  }
}
</script>
